// extracted by mini-css-extract-plugin
module.exports = {"cards":"OrgTeaser_cards__Sr8hS","feature":"OrgTeaser_feature__1Dryy"};